export default "__VITE_ASSET__7DlA2GWq__"